import React, { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { EditableSection } from "@/components/EditableSection";
import { Header } from "@/components/Header";
import { Section } from "@/components/Section";
import { UserContext } from "@/components/User";
import { ICompany } from "@/data/companies";
import { Flex } from "@/eworkitComponents";
import { useCompanyContext } from "@/hooks/User";
import { useToasts } from "@/views/components/Toast/useToasts";
import { ProfileVisibilitySection } from "@/views/Settings/CompanySettings/CompanyData/ProfileVisibility";

export const ConsultantProfilesVisibilitySettings: FC = () => {
  const { t } = useTranslation("session");

  const User = useContext(UserContext);
  const isAdmin = User.hasCompanyAdminPrivileges();
  const Company = useCompanyContext();
  const { addToast } = useToasts();
  const handleCompanyUpdate = (company: ICompany) => {
    User.updateContextCompany(company);

    addToast({ text: t("COMPANY.MY_COMPANY.DATA.UPDATE_SUCCESS_MESSAGE"), type: "success" });
  };

  return (
    <Section padding={["lg"]} borderRadius>
      <Flex direction="column" innerBorder innerPadding="md">
        <Header size="sm" weight="bold" text={t("USERS.SETTINGS.COMPANY_SETTINGS.PROFILES_VISIBILITY")} />
        <EditableSection editable={isAdmin}>
          {editableProps => (
            <ProfileVisibilitySection editableProps={editableProps} record={Company} onUpdate={handleCompanyUpdate} />
          )}
        </EditableSection>
      </Flex>
    </Section>
  );
};
